import 'react-app-polyfill/stable'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import reportWebVitals from './utils/reportWebVitals'
import { ThemeProvider } from './contexts/ThemeContext'
import App from './App'
import { Amplify } from 'aws-amplify'
import { appSyncConfig } from './config'
import { GlobalStyles } from '@mui/material'
import { initDatadog } from './datadog'

Amplify.configure(appSyncConfig)
initDatadog()

render(
  <BrowserRouter>
    <ThemeProvider>
      <GlobalStyles
        styles={{
          "input[type='number']": {
            '-moz-appearance': 'textfield'
          },
          'input::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none'
          },
          'input::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none'
          }
        }}
      />
      <App />
    </ThemeProvider>
  </BrowserRouter>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
